import { shippingCurrency } from "./AramexShippingFields";

const METHOD_LABELS = { cash: "Cash", bank_transfer: "Bank Transfer" };

// Shipping fee collected when the student was moved to Aramex: amount,
// method, date, and the payer for bank transfers. Hidden when none recorded.
export default function ShippingPaymentInfo({ element }) {
  const method = element.aramex_shipping_payment_method;
  if (!method) return null;

  const amount = Number(element.shipping);
  const isTransfer = method === "bank_transfer";

  return (
    <div className="my-1 p-2 border border-blue-200 rounded bg-blue-50 text-sm">
      <span className="font-semibold">Shipping Payment:</span>{" "}
      {Number.isFinite(amount) ? amount.toFixed(2) : element.shipping}{" "}
      {shippingCurrency(element.category)} · {METHOD_LABELS[method] || method}
      {element.aramex_shipping_payment_date && ` · on ${element.aramex_shipping_payment_date}`}
      {isTransfer && (
        <div className="mt-1">
          <label className="font-light">Payer Name:&nbsp;</label>
          <span about="shipping_payer_name">{element.aramex_shipping_payer_name || "—"}</span>
          <span className="mx-2 text-gray-400">|</span>
          <label className="font-light">Payer Phone:&nbsp;</label>
          <span about="shipping_payer_phone">{element.aramex_shipping_payer_phone || "—"}</span>
        </div>
      )}
    </div>
  );
}
